import { ca } from '@cian/analytics';

import { getCustomUrl } from '../../tracking/get_custom_url';
import { IThunkActionCreator } from '../../types/store';
import { getTrackingObject } from '../../utils/analytics';

type TPhoneEventAction =
  | 'Open_KP_card' // Расхлоп (клик на Позвонить) в карточке КП
  // Звонок (через 10 секунд неактивности после клика на Позвонить - см. пример событие в обычной карточке объявления)
  | 'Call_KP_card'
  | 'Open_KP_card_blockKP'
  | 'Open_KP_card_blockMore'
  | 'Open_KP_card_blockDeveloper'
  | 'Open_kp_promotions'
  | 'Open_KP_card_blockKP_popup';

export function trackingPhoneEvent(action: TPhoneEventAction): IThunkActionCreator {
  return (dispatch, getState) => {
    const state = getState();
    const {
      villageData: { village },
    } = state;
    ca('eventSite', {
      name: 'oldevent',
      category: 'Phones',
      action,
      label: village ? getCustomUrl(village) : undefined,
      oid: village.id,
      ...getTrackingObject(state),
    });
  };
}
